module.exports = __webpack_public_path__ + "static/media/23.78de0ae6.jpg";